export const MAX_WIDTH = 1280;